/* Theme diagnostics are local, opt-in and restricted to an allowlist. */
(() => {
  'use strict';
  const configNode = document.querySelector('[data-ol-config]');
  let config = {};
  try { config = JSON.parse(configNode?.textContent || '{}'); } catch { /* Native forms remain available. */ }
  const levels = {debug:10, info:20, warning:30, error:40};
  const enabled = config.diagnostics === true || window.Shopify?.designMode === true;
  const minimum = levels[config.logLevel] || levels.warning;
  const entries = [];
  const allowed = new Set(['operation','requestId','status','durationMs','attempt','component','reason','count']);
  function log(level, event, details = {}) {
    if (!enabled || !(level in levels)) return;
    const data = Object.fromEntries(Object.entries(details).filter(([key,value]) => allowed.has(key) && ['string','number','boolean'].includes(typeof value)));
    const record = {time:new Date().toISOString(),level,event,...data};
    entries.push(record);
    if (entries.length > 60) entries.shift();
    if(levels[level]>=minimum) (level==='warning'?console.warn:level==='error'?console.error:console.info)('[Oud Library]',record);
  }
  function parseJSON(node, fallback) {
    try { return JSON.parse(node?.textContent || 'null') ?? fallback; }
    catch { log('warning','invalid_component_config',{component:'theme'}); return fallback; }
  }
  class RequestError extends Error {
    constructor(message,status=0,uncertain=false) { super(message); this.name='RequestError'; this.status=status; this.uncertain=uncertain; }
  }
  async function request(url, options = {}, operation = 'storefront') {
    const target = new URL(url,location.origin);
    if(target.origin!==location.origin) throw new RequestError('Unsupported request destination');
    const method=(options.method||'GET').toUpperCase();
    const requestId=globalThis.crypto?.randomUUID?.() || `ol-${Date.now()}-${Math.random().toString(36).slice(2,8)}`;
    const limit=method==='GET'?2:1;
    for(let attempt=1;attempt<=limit;attempt++) {
      const controller=new AbortController();
      const started=performance.now();
      const timer=setTimeout(()=>controller.abort(),Math.max(3000,Math.min(20000,config.requestTimeout||10000)));
      try {
        const response=await fetch(target,{credentials:'same-origin',...options,signal:controller.signal});
        const body=await response.text();
        let data=body;
        // Shopify Ajax Cart uses text/javascript for JSON responses on this store.
        const cartJSON = /\/cart(?:\/(?:add|change|update|clear))?\.js$/.test(target.pathname);
        if(cartJSON || response.headers.get('content-type')?.includes('json')) {
          try { data=JSON.parse(body); } catch { throw new RequestError('Invalid server response',response.status,method!=='GET'); }
        }
        if(!response.ok) {
          const error=new RequestError(typeof data==='object'?(data.description||data.message||'Request failed'):'Request failed',response.status);
          if(method==='GET'&&attempt<limit&&(response.status===429||response.status>=500)) {
            const retryAfter=response.headers.get('Retry-After');
            const retrySeconds=Number(retryAfter);
            const retryDelay=Number.isFinite(retrySeconds)?Math.max(400,retrySeconds*1000):Math.max(400,Date.parse(retryAfter)-Date.now());
            // A long server cooldown should fail visibly, not be retried early.
            if(Number.isFinite(retryDelay)&&retryDelay>2000) throw error;
            log('warning','request_retry',{operation,requestId,status:response.status,attempt});
            clearTimeout(timer);
            await new Promise(resolve=>setTimeout(resolve,Number.isFinite(retryDelay)?retryDelay:400));
            continue;
          }
          throw error;
        }
        log('info','request_complete',{operation,requestId,status:response.status,durationMs:Math.round(performance.now()-started),attempt});
        return data;
      } catch(error) {
        const failure=error instanceof RequestError?error:new RequestError(error.name==='AbortError'?'Request timed out':'Connection failed',0,method!=='GET');
        log('error','request_failed',{operation,requestId,status:failure.status,durationMs:Math.round(performance.now()-started),attempt,reason:error.name==='AbortError'?'timeout':'request'});
        throw failure;
      } finally { clearTimeout(timer); }
    }
  }
  function health() {
    return {themeId:window.Shopify?.theme?.id,editor:window.Shopify?.designMode===true,online:navigator.onLine,config:!!configNode,cartForm:!!document.querySelector('.ol-product-form,.ol-cart-form'),diagnostics:enabled,events:entries.slice()};
  }
  window.OudLibrary={config,log,parseJSON,request,RequestError,health};
  log('debug','runtime_ready',{component:'runtime'});
})();

